import DefineDocumentDownloadButton from './view';

export default DefineDocumentDownloadButton;
